
import React, { useState, useEffect } from "react";
// import axios from "axios";

export default function Home() {


  const [useadvertisement, setadvertisement] = useState(null);
  // alert(useadvertisement)
  const [time, setTime] = useState(null);

  useEffect(() => {
    markets();
  }, [])

  const markets = async () => {
    try {
      const response = await fetch(
        "https://a-71ajsatta.com/Admin/public/api/markets",
        { method: "POST" }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.warn(data); // Log the response data
      setadvertisement(data); // Update state with the response data
      // settime(response);
      const livetime = data.livetime; // Accessing livetime from the response data
      setTime(livetime);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return (
    <div>
      <section className="circlebox">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="liveresult">
                <div className="datetime">
                  <div id="clockbox">{time}</div>
                </div>
                <p className="hintext">हा भाई यही आती हे सबसे पहले खबर रूको और देखो</p>
                {/* <div style={{ width: '100%' }}>
                <div className="sattaname">
                  <p>JAY SHRI SHYAM</p>
                </div>
                <div className="sattaresult">
                  <font>
                    <span>54</span>
                  </font>
                </div>
                <div className="sattaname">
                  <p>Shri Ganesh</p>
                </div>
                <div className="sattaresult">
                  <font>
                    <span>Wait</span>
                  </font>
                </div>
                <div className="sattaname">
                  <p>Yamunanagar City</p>
                </div>
                <div className="sattaresult">
                  <font>
                    <span>
                      <strong>
                      <h1 className="text-red blink-soft">Wait</h1>  
                      </strong>
                    </span>
                  </font>
                </div>
              </div> */}

                {useadvertisement &&
                  useadvertisement.data &&
                  useadvertisement.data.livetodayResult &&
                  useadvertisement.data.livetodayResult.length > 0 && (
                    <React.Fragment>
                      {useadvertisement.data.livetodayResult.map((market, index) => (
                        <div className="col-md-12 p-0 col-sm-12 col-xs-12 color-withe" key={index}>
                          <div style={{ color: "white" }}>
                            <p className="livegame">{market.market_name}</p>
                            <p className="liveresult">
                              <p className="liveresult">
                                {/* {market.result <= 9 || market.result === "" ? "Wait" : market.result} */}
                                {/* {market.result <= 9 || market.result === "" ? (
                                  <div class="sattaresult"><font><span><strong><h1 class="text-red blink-soft">Wait</h1></strong></span></font></div>
                                ) : (
                                  market.result
                                )} */}
                                {(market.result === "" || /^\d$/.test(market.result)) ? (
                                  <div className="sattaresult">
                                    <font>
                                      <span>
                                        <strong>
                                          <h1 className="text-red blink-soft">Wait</h1>
                                        </strong>
                                      </span>
                                    </font>
                                  </div>
                                ) : (
                                  market.result
                                )}

                              </p>
                            </p>
                          </div>
                        </div>
                      ))}

                    </React.Fragment>
                  )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
